"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForPromise = exports.timeoutPromise = exports.PromiseTimeoutError = void 0;
class PromiseTimeoutError extends Error {
    constructor(promise) {
        super('Promise timed out');
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.promise = promise;
    }
}
exports.PromiseTimeoutError = PromiseTimeoutError;
const timeoutPromise = async (timeout) => {
    return new Promise((_, reject) => {
        if (timeout) {
            setTimeout(() => {
                reject(new PromiseTimeoutError());
            }, timeout);
        }
    });
};
exports.timeoutPromise = timeoutPromise;
const waitForPromise = async (promise, timeout) => {
    return Promise.race([promise, (0, exports.timeoutPromise)(timeout)]);
};
exports.waitForPromise = waitForPromise;
